import Vue from 'vue'
import Router from 'vue-router'
import Timeline from '@/views/Timeline';
import Chapters from '@/views/Chapters'
import Chapter from '@/views/Chapter';
import Icons from '@/views/Icons';
import About from '@/views/About';
import Acknowledgements from '@/views/Acknowledgements';
import Quiz from '@/views/Quiz';
import Contact from '@/views/Contact';


Vue.use(Router)

export default new Router({
  routes: [
    {
      name: 'Home',
      path: '/',
      component: Timeline
    },
    {
      name: 'Timeline',
      path: '/timeline',
      component: Timeline
    },
    {
      name: 'Chapters',
      path: '/history',
      component: Chapters
    },
    {
      name: 'Chapter',
      path: '/chapter/:id',
      component: Chapter
    },
    {
      name: 'Chapter_',
      path: '/chapter',
      component: Chapters
    },
    {
      name: 'Icons',
      path: '/icons',
      component: Icons
    },
    {
      name: 'About',
      path: '/about',
      component: About
    },
    {
      name: 'Acknowledgements',
      path: '/acknowledgements',
      component: Acknowledgements
    },
    {
      name: 'Quiz',
      path: '/quiz',
      component: Quiz
    },
    {
      name: 'Contact',
      path: '/Contact',
      component: Contact
    }
  ],
  linkActiveClass: "active"
})
